<template>
  <div class="login-wrapper">

    <div class="login-content">
      <div class="left">
        <img
          src="../../assets/login/login-logo.png"
          style="width: 322px; height: 128px"
        >
        <div class="cText">杰宝大王运维管理平台</div>
        <div class="eText">
          Jiebao.King Operation and maintenance Data display
        </div>
      </div>

      <div class="login-form">
        <div class="title">登录/Login</div>
        <el-form ref="form" :model="loginForm" :rules="rules">
          <el-form-item prop="userName">
            <el-input
              v-model="loginForm.userName"
              prefix-icon="el-icon-user"
              @keyup.enter.native="login"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              v-model="loginForm.password"
              type="password"
              prefix-icon="el-icon-lock"
              @keyup.enter.native="login"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="login-btn" @click="login">登录</div>
      </div>
    </div>
  </div>
</template>

<script>

import { setToken } from '@/utils/myAuth.js'
import { loginInfo } from '@/api/user/index.js'

export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        userName: '',
        password: ''
      },
      rules: {
        userName: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      redirect: ''
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  methods: {
    async loginInfo() {
      const res = await loginInfo()
      window.localStorage.setItem('userInfo', JSON.stringify(res.data))
      console.log(window.localStorage.getItem('userInfo'))
    },
    login() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const params = {
            'cid': '',
            'loginName': this.loginForm.userName,
            'password': this.loginForm.password
          }
          this.$axios.post(this.ip + '/sys/login', JSON.stringify(params), {
            headers: {
              'content-type': 'application/json'
            }
          }).then(async(response) => {
            const res = response.data
            if (res.code === 0) {
              await setToken(res.token)
              await this.loginInfo()
              this.$router.push({ path: '/' }).catch(err => err)
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login-wrapper {
  width: 3200px;
  height: 1080px;
  position: relative;
  background: url("../../assets/login/main-bgi.png") no-repeat;
  background-size: 100% 100%;
  .login-content {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 780px;
    height: 311px;
    transform: translate(-50%, -53%);
    display: flex;
    .left {
      color: #ffffff;
      font-weight: 400;

      text-align: center;
      img {
        margin: 47px 0 31px;
      }
      .cText {
        font-size: 17px;
        font-weight: 400;
        letter-spacing: 3px;
        margin-bottom: 11px;
      }
      .eText {
        font-size: 13px;
      }
    }
    .login-form {
      margin-left: 40px;
      padding-left: 30px;
      border-left: 3px solid rgba(4, 81, 255, 0.3);
      .title {
        font-size: 19px;
        margin: 15px 0 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 36px;
        text-align: center;
      }
      ::v-deep .el-form {
          margin: 40px 0 0 30px;
        .el-form-item {
          .el-input {
            .el-input__inner {
              padding-left: 40px;
              width: 350px;
              border: none;
              border-bottom: 2px solid rgba(4, 81, 255, 0.2);
              background-color: transparent;
              color: #fff;
            }
            input::-webkit-input-placeholder {
              color: #fff;
            }
            input::-moz-placeholder {
              color: #fff;
            }
            input:-moz-placeholder {
              color: #fff;
            }
            input:-ms-input-placeholder {
              color: #fff;
            }
          }
        }
      }
      .login-btn {
        width: 146px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background-color: #00a9ff;
        border-radius: 2px;
        font-size: 16px;
        letter-spacing: 2px;
        color: #fff;
        margin: 70px auto 10px;
        cursor: pointer;
      }
    }
  }
}
</style>
